export function selectSession() {
  return (state) => state.session.current;
}
